import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../service';

const ControllerName = "ProviderDoctor"
export const GetAllDoctors = (link) =>
    GetRequest(ControllerName + link)

export const AddDoctor = (UserData) =>
    PostRequest(ControllerName, UserData)

export const GetDoctorInfo = (id) =>
    GetRequest(`${ControllerName}/getInfo/${id}`)


export const UpdateDoctor = (UserData) =>
    PutRequest(ControllerName + "/" + UserData.id, UserData)


export const DeleteDoctor = (Userid) =>
    DeleteRequest(ControllerName + "/" + Userid)

